import React from 'react';
import { Box, Typography } from '@mui/material';
import { countItemsWithStatus } from './board/utils';
import { useListContext } from 'framework/list';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { Tooltip } from 'framework/ui/mui-builder';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { columnNames } from '../constants';

interface HeaderProps {
  data: any[];
}

const Header: React.FC<HeaderProps> = ({ data }) => {
  const { formatDate } = useDateService();
  const { data: { lastUpdate } = {} } = useListContext();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px 0',
          backgroundColor: 'background.default',

          position: 'sticky',
          left: 0,
        }}
      >
        <Tooltip id="last-update-board" title="Last synchronized" arrow placement="bottom">
          <InfoIcon sx={{ color: 'text.secondary', fontSize: '15px', mr: '5px' }} />
        </Tooltip>

        <Typography color="textSecondary">{formatDate(lastUpdate, DATE_FORMAT.DAY_TIME)}</Typography>
      </Box>
      {columnNames.map(({ name, stage }) => {
        const itemsCount = countItemsWithStatus(data, stage);

        return (
          <Box
            key={`header-${name}`}
            sx={{
              borderBottom: '1px solid',
              borderColor: 'border.contrast',
              display: 'flex',
              justifyContent: 'center',
              padding: '15px 0',
              backgroundColor: 'background.default',
            }}
          >
            <Typography color="textSecondary">{`${name} (${itemsCount})`}</Typography>
          </Box>
        );
      })}
    </>
  );
};

export default Header;
